/**
 * open-player.js — single entry point the views use to open a film.
 *
 *   - Native shell (window.zapShell injected by zap-client-shell / native
 *     WebViews): the native QML player owns the WHOLE experience — video
 *     surface, controls, track menus, fullscreen, close. We mount NO SPA
 *     web-player overlay; NativeShellSession just drives window.zapShell.
 *   - Browser (no shell): the unchanged WASM ZapPlayer (modal + canvas).
 *
 * Gate on the PRESENCE of window.zapShell (synchronous), not getShell()
 * (apiVersion-gated): the QWebChannel handshake can complete slightly after the
 * object is injected, so an early open would otherwise misroute embedded → web.
 * NativeShellSession resolves readiness/version internally (getShellWhenReady)
 * and degrades to the web player if the shell turns out to be incompatible.
 *
 * Both branches return an object with destroy() + honour opts.onClose, so the
 * views are agnostic: `this._player = openPlayer({...})` then `_player.destroy()`.
 */

import { ZapPlayer } from './zap-player.js';
import { NativeShellSession } from './shell/native-session.js';

export function openPlayer(opts = {}) {
  const shellPresent = typeof globalThis !== 'undefined' && !!globalThis.zapShell;
  const embedded = (opts.features?.embedded !== false) && shellPresent;
  return embedded ? new NativeShellSession(opts) : new ZapPlayer(opts);
}
